import { useQuery } from '@tanstack/react-query';
import { getSupportTicketOrderCandidates, queryKeys } from '@vgrubs/components';

/** The route's ceiling. One screenful of a modal, so there is no paging. */
const LIMIT = 50;

/**
 * The orders a ticket could be about, searched by number, customer or id.
 *
 * Scoped by the server to the merchant who opened the ticket, so nothing here
 * can attach somebody else's order - which the general orders list could, and
 * is why it is no longer used for this.
 */
export const useTicketOrderCandidates = ({
  ticketId,
  query,
  enabled,
}: {
  ticketId: number | null;
  query: string;
  enabled: boolean;
}) => {
  const search = useQuery({
    queryKey: queryKeys.supportTickets.orderCandidates(ticketId ?? 0, query),
    queryFn: async () => {
      const { data } = await getSupportTicketOrderCandidates(
        ticketId as number,
        { query: query || null, limit: LIMIT }
      );
      return data.data;
    },
    enabled: enabled && ticketId !== null,
  });

  return {
    orders: search.data ?? [],
    isLoading: search.isLoading,
    failed: search.isError,
  };
};
